import React from 'react';
import styled from 'styled-components/macro';
import Portrait from '../../assets/images/Peter_Portrait_150.jpg';
import Footer from '../Footer/Footer';
import { ButtonLink, ButtonNoBorder } from '../UI/Button/Button';
import ScrollToTop from '../../hoc/ScrollToTop';

const AboutContainer = styled.div`
  width: 100%;
  height: 100%;
  /* background: yellow; */
  padding-top: 96px;
`;

const PortraitWrapper = styled.div`
  width: 150px;
  height: 150px;
  margin-left: auto;
  margin-right: auto;
`;

const PortraitImg = styled.img`
  height: 100%;
  width: auto;
`;
const AboutText = styled.div`
  margin-top: 48px;
  margin-left: auto;
  margin-right: auto;
  padding: 0 16px;
  font-family: Lato;
  font-weight: 400;
  font-style: normal;
  font-size: 17px;
  text-align: left;
  line-height: 25px;
  max-width: 500px;
  /* min-width: 310px; */
`;

const FooterContainer = styled.div`
  position: absolute;
  width: 100%;
  bottom: 0;

  @media (max-height: 1044px) {
    position: relative;
    margin-top: 70px;
  }
  /* margin: 0; */
  /* overflow: hidden; */
  /* margin-top: 64px; */
`;

const StyledP = styled.p`
  margin-bottom: 13px;
`;

const ButtonWrapper = styled.div`
  text-align: center;
  margin-bottom: 40px;
`;

const AboutMe = () => {
  return (
    <ScrollToTop>
      <AboutContainer>
        <PortraitWrapper>
          <PortraitImg src={Portrait} alt="Portrait" />
        </PortraitWrapper>
        <AboutText>
          <StyledP>
            Designer, reﬁner, developer. Lover of simplicity, type, and color.{' '}
          </StyledP>
          <StyledP>
            I’m a UX | UI Designer & front-end developer with a background in
            communication design.
          </StyledP>
          <StyledP>
            Creating meaningful user experiences through significant research,
            intentional information architecture, intuitive user interfaces and
            good code is the challenge that drives me.
          </StyledP>
          <StyledP>
            I enjoy working with teams and like to see projects from concept
            through to completion, be it talking with customers, crafting
            beautiful visual design or writing clever code.
          </StyledP>
          <StyledP>
            Besides product design, I have a profound interest in learning new
            skills, such as Vue.js and exploring animation tools like After
            Effects and Principle.
          </StyledP>
          <StyledP>
            When I’m not concepting, coding, or pushing pixels, you’ll find me
            sketching, cooking, hiking or just dancing silly with my kids.
          </StyledP>
          <StyledP>
            Please download my resume for more information about my education,
            work experience, and technical skill set.
          </StyledP>
          <ButtonWrapper>
            <ButtonLink
              to="/files/PeterFrommann_Resume.pdf"
              target="_blank"
              download
            >
              Download Resume
            </ButtonLink>
          </ButtonWrapper>
          <StyledP>
            <ButtonNoBorder href="mailto:info@peterfrommann.de" title="mail">
              Let’s get in touch!
            </ButtonNoBorder>
            &nbsp; I’d love to chat.
          </StyledP>
        </AboutText>
        <FooterContainer>
          <Footer />
        </FooterContainer>
      </AboutContainer>
    </ScrollToTop>
  );
};

export default AboutMe;
